(function ($) {
    showPostalCode();
    
    $("#country_id, #billing_country_id").on('change', function(){
        var countryId = $(this).val(),
            _this = $(this),
            lang = $(this).data('lang'),
            selectId = $(this).data('select-id');

        getPostalCodeByCountry(countryId, _this, null, lang, selectId);
    });
})(jQuery);

function showPostalCode() {
    if($("#country_id, #billing_country_id").length) {
        $("#country_id, #billing_country_id").map(function () {
            var countryId = $(this).val(),
                _this = $(this),
                postalCodeId = $(this).data('postal-code'),
                oldPostalCodeId = $(this).data('old-postal-code'),
                lang = $(this).data('lang'),
                selectId = $(this).data('select-id');
            
            if (typeof oldPostalCodeId != 'undefined') {
                postalCodeId = oldPostalCodeId;
            }

            getPostalCodeByCountry(countryId, _this, postalCodeId, lang, selectId);
        });
    }
};

function getPostalCodeByCountry(countryId, _this, postalCodeId, lang, selectId) {
    $.ajax({
        type: 'POST',
        url: _this.data('route'),
        data: {
            "_token": $("input[name='_token']").val(),
            "id": countryId
        }
    })
    .done(function (respon) {
        if(respon.status) {
            var datas = respon.data;

            // console.log('postalCodeId', countryId, postalCodeId);
            $(selectId).html('<option value="">'+lang+'</option>');
            $(datas).each(function(i){
                var selected = postalCodeId == datas[i].id ? 'selected="selected"' : '';
                //to list postal code
                $(selectId).append('<option '+selected+' value="'+datas[i].id+'">'+datas[i].postal_code+' '+datas[i].city+'</option>');
            });
        }
    });
}